import { useSyncExternalStore } from 'react';
import {
  Breakpoint,
  MOBILE_MEDIA_QUERY,
  TABLET_MEDIA_QUERY,
} from '../constants/breakpoints';

function resolveBreakpoint(): Breakpoint {
  if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) return 'mobile';
  if (window.matchMedia(TABLET_MEDIA_QUERY).matches) return 'tablet';
  return 'desktop';
}

function subscribe(onChange: () => void): () => void {
  const mobileList = window.matchMedia(MOBILE_MEDIA_QUERY);
  const tabletList = window.matchMedia(TABLET_MEDIA_QUERY);
  mobileList.addEventListener('change', onChange);
  tabletList.addEventListener('change', onChange);
  return () => {
    mobileList.removeEventListener('change', onChange);
    tabletList.removeEventListener('change', onChange);
  };
}

export function useBreakpoint(): Breakpoint {
  return useSyncExternalStore(subscribe, resolveBreakpoint, resolveBreakpoint);
}
